import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { MenuGroupsContainer } from "../../styled/setting";

import Info from "../common/info";
import GroupItem from "./groupItem";

const MenuGroups = ({
  transformValue,
  data = [],
  changeTab,
  context,
  setContext,
  openModal,
  closeModal,
  selectCompany,
  getMenuGroup,
  clickImages,
  toggleModal,
  changeStatus,
}) => {
  // 메뉴 그룹 삭제
  const removeGroup = async (id) => {
    const url = "/erp/menuGroup/delete";
    const body = { id, cmpnyNo: selectCompany.value };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("메뉴 그룹이 삭제되었습니다.");
        await getMenuGroup();
      }
    } catch (error) {
      console.log(error);
      toast.error("잠시 후 다시 시도해주세요");
    } finally {
      setContext(null);
      closeModal();
    }
  };

  // 메뉴 그룹에서 상품 삭제
  const removeProduct = async (group, productId) => {
    const url = "/erp/menuGroup/update";
    const body = {
      input: {
        id: group.id,
        name: group.name,
        cmpnyNo: selectCompany.value,
        productIds: [...group.products].filter((item) => item.id !== productId).map(({ id }) => id),
      },
    };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success(`상품이 메뉴 그룹에서 삭제되었습니다.`);
        await getMenuGroup();
      }
    } catch (error) {
      console.log(error);
      toast.error("잠시 후 다시 시도해주세요");
    } finally {
      setContext(null);
      closeModal();
    }
  };

  return (
    <MenuGroupsContainer
      className="slideContent"
      style={{ transform: `translateX(${transformValue}%)` }}>
      <Info
        message={`메뉴 그룹 **${data.length}**개`}
        actions={[
          { label: "순서변경", func: () => toggleModal("order"), key: "toggle" },
          { label: "추가", func: () => changeTab(2), key: "add" },
          !data.length && { label: "메뉴추가", func: () => toggleModal("product"), key: "toggle" },
        ].filter(Boolean)}
      />
      <div className="contents">
        {data && data.length > 0 ? (
          <ul className="menuGroups">
            {data.map((item) => (
              <li key={item.id}>
                <GroupItem
                  item={item}
                  context={context}
                  setContext={setContext}
                  changeTab={changeTab}
                  openModal={openModal}
                  closeModal={closeModal}
                  removeGroup={removeGroup}
                  removeProduct={removeProduct}
                  clickImages={clickImages}
                  toggleModal={toggleModal}
                  changeStatus={changeStatus}
                />
              </li>
            ))}
          </ul>
        ) : (
          <>메뉴 그룹이 존재하지 않습니다.</>
        )}
      </div>
    </MenuGroupsContainer>
  );
};

export default MenuGroups;
